import * as types from '../../constants/log/breedLogConstants';

export const breedLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    breedType,
    account,
    nftUid,
    parentNftUid,
    callback,
    error
  }
) => ({
  type: types.BREEDLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  breedType,
  account,
  nftUid,
  parentNftUid,
  callback,
  error
});

export const breedLogList = (list) => ({
  type: types.BREEDLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setBreedLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_BREEDLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const breedLogPageReset = () => ({
  type: types.BREEDLOG_PAGE_RESET,
});
